<template>
  <g>
    <path
      d="M13.5235 8.34351H25.9967C26.9547 8.34351 27.7325 9.1213 27.7325 10.0793V22.249C27.7325 23.207 26.9547 23.9848 25.9967 23.9848H12.0913H10.3554H8.61014H6.00168C5.04366 23.9848 4.26587 23.207 4.26587 22.249V10.0793C4.26587 9.1213 5.04366 8.34351 6.00168 8.34351H8.04102"
      :stroke="iconColor"
      stroke-width="1.6"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.98877 11.8128V7.46851H12.4699V11.8128"
      :stroke="iconColor"
      stroke-width="1.6"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.6235 17.5811V21.3657L10.7264 20.4172L8.83887 21.3657V17.5811"
      :stroke="iconColor"
      stroke-width="1.6"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.3035 11.4254C11.626 11.6625 12.2046 11.8997 12.5935 11.9661C12.9824 12.023 13.3523 12.3929 13.4092 12.7818C13.4661 13.1802 13.7033 13.7588 13.9404 14.0813C14.1775 14.4038 14.1775 14.9255 13.9404 15.2385C13.7033 15.561 13.4661 16.1396 13.4092 16.5285C13.3523 16.9174 12.9824 17.2873 12.5935 17.3442C12.1951 17.4012 11.6165 17.6478 11.3035 17.8754C10.981 18.1126 10.4593 18.1126 10.1463 17.8754C9.82377 17.6383 9.24517 17.4012 8.85627 17.3442C8.45789 17.2873 8.09745 16.9174 8.03105 16.5285C7.97414 16.1301 7.737 15.5515 7.49987 15.2385C7.26274 14.916 7.26274 14.3943 7.49987 14.0813C7.737 13.7588 7.97414 13.1802 8.03105 12.7818C8.08796 12.3929 8.45789 12.023 8.85627 11.9661C9.24517 11.8997 9.82377 11.6625 10.1463 11.4254C10.4688 11.1883 10.9905 11.1883 11.3035 11.4254Z"
      :stroke="iconColor"
      stroke-width="1.6"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#ee1c25"
    }
  }
};
</script>
